module.exports = __webpack_public_path__ + "img/gonetwork1_2.2c659d27.png";